import type { ComponentProps } from "react";

export function Home(props: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 25 25"
			fill="none"
			{...props}
		>
			<circle cx={12.238} cy={6.486} r={1.5} fill="currentColor" />
			<circle cx={12.238} cy={19.486} r={1.5} fill="currentColor" />
			<circle
				cx={5.738}
				cy={12.986}
				r={1.5}
				fill="currentColor"
				transform="rotate(-90 5.738 12.986)"
			/>
			<circle
				cx={18.738}
				cy={12.986}
				r={1.5}
				fill="currentColor"
				transform="rotate(-90 18.738 12.986)"
			/>
			<circle
				cx={7.642}
				cy={8.39}
				r={1.5}
				fill="currentColor"
				transform="rotate(-45 7.642 8.39)"
			/>
			<circle
				cx={16.834}
				cy={17.582}
				r={1.5}
				fill="currentColor"
				transform="rotate(-45 16.834 17.582)"
			/>
			<circle
				cx={7.642}
				cy={17.582}
				r={1.5}
				fill="currentColor"
				transform="rotate(-135 7.642 17.582)"
			/>
			<circle
				cx={16.834}
				cy={8.39}
				r={1.5}
				fill="currentColor"
				transform="rotate(-135 16.834 8.39)"
			/>
		</svg>
	);
}
